import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';
import { withRouter } from 'react-router';

import 'assets/scss/subscriptionModal.css';
import SubscriptionModal from './subscriptionModal';

const ManageSubscriptionModal = ({
  isVisible,
  toggleModal,
  toggleCancelSubscription,
  history,
  plan_status,
}) => {
  const upgradePlan = () => {
    history.push('/renew/select-plan');
  };

  const planStatus = { title: '', ...plan_status };
  const planText = planStatus.title.includes('trial')
    ? '7 Day Trial Plan'
    : `${planStatus.title} Plan`;
  const isTrialPlan = planStatus.title.includes('trial');
  const isProPlan = planStatus.title.includes('pro');

  return (
    <SubscriptionModal
      isVisible={isVisible}
      toggleModal={toggleModal}
      confirmText="Proceed to cancelation"
      noFooter
    >
      <div className="modal-body">
        <div className="current-plan text-secondary mt-4">Current Plan</div>
        <div className="plan-name text-capitalize">{planText}</div>
        <div className="subscription-info py-5 px-md-4 p-3">
          <div
            className={`upgrade-text pr-md-3 pr-0 mb-md-0 mb-4 ${isProPlan &&
              'd-none'}`}
          >
            Upgrade to pro and get access to unlimited Add-Ons Support
          </div>
          <button
            type="button"
            onClick={upgradePlan}
            className={`btn btn-lg btn-upgrade py-3 px-4 ${isProPlan &&
              'd-none'}`}
          >
            Upgrade Plan
          </button>
        </div>
      </div>
      <div className="modal-footer p-0">
        <div className="subscription-option py-4 px-md-4 p-3">
          <div className="mr-lg-3 mr-0">
            <div className="option-text mb-md-0 mb-4">
              Are you looking to pause or even cancel account? Before you go
              please know that we will sincerely miss you
            </div>
          </div>
          <div className="action-btn">
            <UncontrolledTooltip placement="top" target="freezeSubscription">
              Freezing your subscription is currently not available. Please
              contact a Customer Success representative for help
              info@mysoono.com.
            </UncontrolledTooltip>
            {isTrialPlan && (
              <UncontrolledTooltip placement="top" target="cancelSubscription">
                Unavailable for trial plan
              </UncontrolledTooltip>
            )}
            <button
              className="mx-auto btn btn-sm btn-freeze"
              id="freezeSubscription"
              type="button"
            >
              Freeze Account
            </button>
            <button
              className="mx-auto btn btn-sm btn-cancel mt-2"
              type="button"
              id="cancelSubscription"
              onClick={isTrialPlan ? () => {} : toggleCancelSubscription}
            >
              Cancel Account
            </button>
          </div>
        </div>
      </div>
    </SubscriptionModal>
  );
};

ManageSubscriptionModal.defaultProps = {
  isVisible: false,
  toggleCancelSubscription: () => {},
};

ManageSubscriptionModal.propTypes = {
  isVisible: PropTypes.bool,
  toggleModal: PropTypes.func.isRequired,
  toggleCancelSubscription: PropTypes.func,
};

export default withRouter(ManageSubscriptionModal);



// WEBPACK FOOTER //
// ./src/components/Modal/subscription/manageSubscription.js